import { useSocket } from "../lib/socket";
import type { User } from "../types";
import { AppFrame } from "./AppFrame";

/**
 * The frame for screens that belong to the platform rather than to a product:
 * the rail, and nothing else.
 *
 * Settings and the notification history are both of these. Settings used to
 * render inside the Helpdesk's shell, which meant a page about channels,
 * teams, pipelines and CRM fields sat next to a column listing Unassigned, My
 * mentions and All closed tickets -- a set of ticket queues beside a screen
 * with no tickets on it, taking a quarter of the width on a narrow window.
 *
 * It is also the wrong claim to make. There is one users table and one role
 * column behind every product here, which is the whole argument for a single
 * settings page; framing it in one product's chrome says the opposite. The
 * notification history has the same shape of problem from the other direction
 * -- it deliberately spans all four products, so putting any one product's
 * navigation beside it would be picking a side.
 *
 * The rail stays, so getting back out is one click, and each screen's own tabs
 * do the navigating within it.
 *
 * No `ActivityDrawerProvider`. Nothing on these pages opens a contact or a
 * company, and a provider with no consumers is a thing the next person has to
 * read before working out that it does nothing.
 */
export function PlatformShell({ user, title }: { user: User; title: string }) {
  const { connected } = useSocket();

  return (
    <AppFrame
      user={user}
      title={title}
      connected={connected}
    />
  );
}
